/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DigitizingserviceMelcoDigitizingModelsTranslateRequest
 */
export interface DigitizingserviceMelcoDigitizingModelsTranslateRequest {
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsTranslateRequest
     */
    text?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DigitizingserviceMelcoDigitizingModelsTranslateRequest
     */
    languages?: Array<string> | null;
}

export function DigitizingserviceMelcoDigitizingModelsTranslateRequestFromJSON(json: any): DigitizingserviceMelcoDigitizingModelsTranslateRequest {
    return DigitizingserviceMelcoDigitizingModelsTranslateRequestFromJSONTyped(json, false);
}

export function DigitizingserviceMelcoDigitizingModelsTranslateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingserviceMelcoDigitizingModelsTranslateRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'text': !exists(json, 'text') ? undefined : json['text'],
        'languages': !exists(json, 'languages') ? undefined : json['languages'],
    };
}

export function DigitizingserviceMelcoDigitizingModelsTranslateRequestToJSON(value?: DigitizingserviceMelcoDigitizingModelsTranslateRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'text': value.text,
        'languages': value.languages,
    };
}


